import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../../shared/enums/request-status';
import {
  resetPasswordRequest,
  getAnonymousUserHashRequest,
} from './extra-actions';

type State = {
  status: RequestStatus;
  message: string;
  error: any;
  email: string;
  showError: boolean;
  anonymousUserHashStatus: RequestStatus;
  anonymousUserHashMessage: string;
  anonymousUserHashError: any;
  anonymousUserHash: string | null;
  anonymousUserId: string | null;
};

const initialState: State = {
  status: RequestStatus.Ideal,
  message: '',
  error: '',
  email: '',
  showError: false,
  anonymousUserHashStatus: RequestStatus.Ideal,
  anonymousUserHashMessage: '',
  anonymousUserHashError: null,
  anonymousUserHash: null,
  anonymousUserId: null,
};

const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    hideError: (state) => {
      state.showError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPasswordRequest.pending, (state) => {
      state.status = RequestStatus.Pending;
      state.showError = false;
    });
    builder.addCase(resetPasswordRequest.fulfilled, (state, action) => {
      state.status = RequestStatus.Succeeded;
      state.message = action.payload.message;
      state.email = action.meta.arg.email;
    });
    builder.addCase(resetPasswordRequest.rejected, (state, action) => {
      state.status = RequestStatus.Failed;
      state.error = action.payload;
      state.showError = !action.payload.isHandled;
    });

    builder.addCase(getAnonymousUserHashRequest.pending, (state) => {
      state.anonymousUserHashStatus = RequestStatus.Pending;
      state.anonymousUserHashError = null;
    });
    builder.addCase(getAnonymousUserHashRequest.fulfilled, (state, action) => {
      state.anonymousUserHashStatus = RequestStatus.Succeeded;
      state.anonymousUserHashMessage = action.payload.message || '';
      state.anonymousUserHash = action.payload.payload?.userHash || null;
      state.anonymousUserId =
        action.payload.payload?.anonymousUserId != null
          ? String(action.payload.payload.anonymousUserId)
          : null;
    });
    builder.addCase(getAnonymousUserHashRequest.rejected, (state, action) => {
      state.anonymousUserHashStatus = RequestStatus.Failed;
      state.anonymousUserHashError = action.payload;
    });
  },
});

export const { hideError } = resetPasswordSlice.actions;
export { resetPasswordRequest, getAnonymousUserHashRequest };
export default resetPasswordSlice.reducer;
